import React from "react";
import ResultsTailwind from "../admin/ResultsTailwind";
import TailwindPageWrapper from "../generic/TailwindPageWrapper";

function PublicResults() {
  return (
    <TailwindPageWrapper>
      <div className="-mt-24">
        <ResultsTailwind />
      </div>
    </TailwindPageWrapper>
  );
}

export default PublicResults;

